export default __webpack_public_path__ + "static/media/discord.f0290874.svg";